<template>
  <div>
    <v-progress-linear
      v-if="isItemLoading"
      class="mt-5 mb-7"
      indeterminate
      rounded
    />

    <div v-else>
      <h6 class="text-uppercase grey--text">
        {{ $t('item.label.name') }}
      </h6>
      <p class="body-2">
        {{ item && item.name ? item.name : '---' }}
      </p>

      <h6 class="text-uppercase grey--text">
        {{ $t('item.label.category') }}
      </h6>
      <p class="body-2">
        {{ item && item.category ? item.category.name : '---' }}
      </p>

      <h6 class="text-uppercase grey--text">
        {{ $t('item.label.createdAt') }}
      </h6>
      <p class="body-2">
        {{ item && item.date_created ? formatDate(item.date_created) : '---' }}
      </p>

      <h6 class="text-uppercase grey--text">
        {{ $t('item.label.preset') }}
      </h6>
      <p class="body-2">
        {{ item && item.preset ? $t(`item.label.${item.preset}`) : '---' }}
      </p>

      <h6 class="text-uppercase grey--text">
        {{ $t('item.label.description') }}
      </h6>
      <p class="body-2">
        {{ item && item.description ? item.description : '---' }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { catalogDate } from '@/util/catalog'

export default {
  name: 'ItemDetails',

  computed: {
    ...mapGetters(['item', 'isItemLoading']),
  },

  data() {
    return {
      formatDate: catalogDate,
    }
  },
}
</script>
